import React, { Component } from "react";
import styled from "styled-components";
import FlipMove from "react-flip-move";

import { HCenter, VCenter } from "./layout";
import * as Colors from "./colors";

export const HeaderAction = styled.div`
  ${HCenter};
  ${VCenter};
  flex-direction: column;
  cursor: pointer;
  &:hover {
    color: ${Colors.hoverPrimary};
  }
  color: ${Colors.Text};
`;

export const ActionIcon = styled.div`
  font-size: 1.5em;
  width: 25px;
  height: 25px;
  text-align: center;
`;

export const ElementUI = styled.div`
  font-size: 1.7em;
  color: #333;
  width: 35px;
  height: 35px;
  cursor: pointer;
`;

export const ElementToolTip = styled.span`
  background-color: #444;
  padding: 6px 8px;
  color: white;
  border-radius: 10px;
  position: absolute;
  left: 50px;
  opacity: 0;
  transition: opacity 0.3s ease-out;
  white-space: nowrap;
`;

export const InputUI = styled.input`
  width: ${p => (p.large ? "100%" : p.width || "100px")};
  padding: 3px 7px 4px 7px;
  border-radius: 6px;
  box-shadow: none;
  outline: none;
  border-style: solid;
  background-color: ${p => (p.disabled ? Colors.darkenSecondary(0.3) : Colors.primary)};
  border-color: ${Colors.darkenSecondary(0.4)};
  border-width: ${p => (p.border ? "0px" : "1px")};
  line-height: normal;
`;

export const Box = styled.div`
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.3), 0 0 0 1px rgba(10, 10, 10, 0.3);
  padding-bottom: 15px;
  border-radius: 5px;
`;

export const ModalTitle = styled.div`
  width: 100%;
  text-align: center;
  padding: 20px;
  text: ${Colors.Text};
  background-color: ${Colors.primary};
  border-top: 5px solid ${Colors.darkenPrimary(0.4)};
  border-radius: 5px 5px 0px 0px;
  line-height: 1.4em;
`;

export class Slider extends Component {
  constructor(p) {
    super(p);
    this.state = { direction: -1 };
  }

  componentWillReceiveProps = p => {
    if (this.props.slide !== p.slide)
      this.setState({ direction: p.preview ? -1 : this.props.slide - p.slide });
  };

  transformX = x => ({ transform: "translate(" + x + "px)" });

  animSlide = dist => ({
    enterAnimation: { from: this.transformX(-dist * this.props.width), to: this.transformX(0) },
    leaveAnimation: { from: this.transformX(0), to: this.transformX(dist * this.props.width) }
  });

  animFade = dist => ({
    enterAnimation: { from: { opacity: 0 }, to: { opacity: 1 } },
    leaveAnimation: { from: { opacity: 1 }, to: { opacity: 0 } }
  });

  transitions = {
    [SlideShowTransitions.Slide]: this.animSlide,
    [SlideShowTransitions.Fade]: this.animFade
  };

  render() {
    return (
      <FlipMove
        {...this.transitions[this.props.transition || SlideShowTransitions.Slide](
          this.state.direction
        )}
        duration={this.props.duration}>
        <div key={this.props.slide}>
          {this.props.children[Math.min(this.props.slide, this.props.children.length) - 1]}
        </div>
      </FlipMove>
    );
  }
}

export const SlideShowTransitions = {
  Slide: "Slide",
  Fade: "Fade"
};



// WEBPACK FOOTER //
// ./src/reusable/components.js